import { problemTypes } from "../../jsxProviders";
import { ProblemLayers } from "../UIStore";
type ProblemInfo = { name: string; text: string[] };
type CombinedErrors = {
  [key in problemTypes]: ProblemInfo[];
};
export function combineErrors(problemLayers: ProblemLayers) {
  const combinedErrors: CombinedErrors = {
    Wav: [],
    AudOffset: [],
    AudLock: [],
    VidTrack: [],
    CompCollapse: [],
    TextDeformed: [],
    UnsupportedFormat: [],
    LayerLocked: [],
    NameError: [],
    FontError: [],
    UnknownError: [],
  };
  for (const composition of problemLayers) {
    const keys = Object.keys(composition.errors);
    keys.forEach((key) => {
      const currentKey = key as keyof typeof composition["errors"];
      if (
        combinedErrors.hasOwnProperty(key) &&
        composition.errors[currentKey].length
      ) {
        const err: ProblemInfo = {
          name: composition.name,
          text: composition.errors[currentKey],
        };
        combinedErrors[currentKey].push(err);
      }
    });
  }
  return combinedErrors;
}
